var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 496.42 237.12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2,.cls-3,.cls-4{fill:none;}.cls-1,.cls-2,.cls-3{stroke:#474bf5;}.cls-1,.cls-3,.cls-4{stroke-miterlimit:10;}.cls-1{stroke-width:15.56px;}.cls-2,.cls-3,.cls-4{stroke-linecap:round;stroke-width:18.17px;}.cls-2{stroke-linejoin:round;}.cls-4{stroke:#ff462f;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_498",
    "data-name": "Group 498"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_297",
    "data-name": "Path 297",
    className: "cls-1",
    d: "M488.64,26.22v186a17.14,17.14,0,0,1-17.13,17.14h-291a17.13,17.13,0,0,1-17.13-17.14h0v-186A17.13,17.13,0,0,1,180.48,9.09h291a17.13,17.13,0,0,1,17.14,17.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_298",
    "data-name": "Path 298",
    className: "cls-2",
    d: "M486.46,17.85a5.38,5.38,0,0,1-1.36,6.9L352.77,127.83a45.58,45.58,0,0,1-53.55,0L166.89,24.74a5.38,5.38,0,0,1-1.36-6.89,17.12,17.12,0,0,1,15-8.76h291A17.12,17.12,0,0,1,486.46,17.85Z"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_95",
    "data-name": "Line 95",
    className: "cls-3",
    x1: 168.11,
    y1: 210.98,
    x2: 263.68,
    y2: 136.52
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_96",
    "data-name": "Line 96",
    className: "cls-3",
    x1: 388.31,
    y1: 136.52,
    x2: 483.89,
    y2: 210.98
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_97",
    "data-name": "Line 97",
    className: "cls-4",
    x1: 132.71,
    y1: 64.15,
    x2: 99.53,
    y2: 64.15
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_98",
    "data-name": "Line 98",
    className: "cls-4",
    x1: 132.71,
    y1: 103.53,
    x2: 70.35,
    y2: 103.53
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_99",
    "data-name": "Line 99",
    className: "cls-4",
    x1: 132.71,
    y1: 142.92,
    x2: 39.72,
    y2: 142.92
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_100",
    "data-name": "Line 100",
    className: "cls-4",
    x1: 132.71,
    y1: 182.3,
    x2: 9.09,
    y2: 182.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.33700cfd972513a5dcb711b3c0912be6.svg";
export { ForwardRef as ReactComponent };